const VALID_CATEGORIES = [
  "Frete + Taxas de Frete",
  "Taxas de Origem",
  "Taxas de Destino",
  "Taxas Adicionais",
  "Destination",
  "Origin",
  "Freight",
  "Detention",
  "penaltyFees",
];

function isValid(str?: string): boolean {
  return typeof str === "string" && str.trim().length > 0;
}

export function isValidCategory(str?: string): boolean {
  const valid = isValid(str) && VALID_CATEGORIES.includes(str!.trim());
  return valid;
}

export function resolveCategory(
  category?: string,
  categoryName?: string
): string {
  const cat = isValid(category) ? category!.trim() : undefined;
  const catName = isValid(categoryName) ? categoryName!.trim() : undefined;

  const catIsValid = isValidCategory(cat);
  const catNameIsValid = isValidCategory(catName);

  let result: string;

  if (catIsValid) {
    result = catName ?? cat!;
  } else if (catNameIsValid) {
    result = cat ?? catName!;
  } else if (cat) {
    result = cat;
  } else if (catName) {
    result = catName;
  } else {
    result = "Unknown";
  }
  return result;
}
